import {
    ERROR_MESSAGES,
    SUCCESS_MESSAGES,
} from 'utils/constants/toastMessages';

import { API_UPDATE_MAKER_REQUEST } from 'utils/API/apiUrls';
import { POST } from 'utils/fetchWrappers';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import { FormElems } from 'components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { cleanCheckerRemarks, isApproveRejectDisable, transformCheckerData } from './mleMakerChecker.utils';
import { APPROVE, REJECT, SUBMIT_CHECKER } from './constant';
import SubmitButton from './SubmitButton';

const MleCheckerApprovalForm = ({
    requestDetails,
    auth,
    closePopup,
    showLoader,
    hideLoader,
    isBDOnboarding,
    checkerRemarks,
    raisedToLevel,
    isViewMode,
    parentEventType
}) => {
    const loggedInUserLevel = auth?.userDetails?.level;
    
    const [comment, setComment] = useState(requestDetails?.remarks || null);
    const [isApproved, setIsApproved] = useState('');
    const [buttonAction, setButtonAction] = useState(''); // Tracks the button action.
    const [approveDisable, setApproveDisable] = useState(true);
    const history = useHistory();

    useEffect(() => {
        setApproveDisable(isApproveRejectDisable(checkerRemarks))
    }, [checkerRemarks]);

    const validateCheckerRemarks = (checkerRemarks) => {
        // Normalize checkerRemarks to always be a flat array
        const normalizedRemarks = checkerRemarks;
        if (!normalizedRemarks || normalizedRemarks.length === 0) {
          toast.error('Please select a status for all items.');
          const firstRadioButton = document.querySelector(`input[type="radio"]:not(:checked)`);
          if (firstRadioButton) {
            firstRadioButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstRadioButton.focus(); // Optionally focus the element for better user experience
          }
          return false; // Validation failed
        }
      
        // Check if all radio buttons are selected
        const unselectedRadioIndex = normalizedRemarks.findIndex((item) => !item.status);
        if (unselectedRadioIndex !== -1) {
            toast.error('Please select a status for all items.');
            const unselectedRadio = document.querySelector(
                `input[type="radio"][name="${unselectedRadioIndex}"]:not(:checked)`
            );
            if (unselectedRadio) {
                unselectedRadio.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false; // Validation failed
        }
      
        // Check if rejected items have remarks
        const invalidCheckerRemarksIndex = normalizedRemarks.findIndex(
                (item) => item.status === REJECT && (!item.remarks || item.remarks.trim().length < 2));
            if (invalidCheckerRemarksIndex !== -1) {
                toast.error('Remarks are mandatory for rejected items and must be at least 2 characters long.');
                const invalidRemarkInput = document.querySelector(
                    `.eachRemarks[name="${invalidCheckerRemarksIndex}"]`
                );
                if (invalidRemarkInput) {
                    invalidRemarkInput.classList.add('input-error');
                    invalidRemarkInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return false; // Validation failed
            }
      
        return true; // Validation passed
      };
      
    const handleFormSubmit = async event => {
        event.preventDefault();
        // in case when checkerRemakrs has two array in it 
        const normalizedCheckerRemarks = Array.isArray(checkerRemarks)
            ? [...checkerRemarks]
            : transformCheckerData(checkerRemarks);
        let transformedCheckerRemarks = [];
        if (Array.isArray(normalizedCheckerRemarks)) {
            transformedCheckerRemarks = cleanCheckerRemarks(normalizedCheckerRemarks);
        }

        const payload = {
            makerRequestId: requestDetails.makerRequestId,
            remarks: comment,
            eventType: requestDetails.eventType,
            status: isApproved ? 'APPROVED' : requestDetails?.eventType == "RISK_DETAIL_SECTION" ? "REJECTED" : 'CHECKER_REJECTED',
            remarkBy: auth.userDetails.email || '',
            checkerRemarks: transformedCheckerRemarks,
            raisedToLevel: buttonAction === 'RAISE_TO_LEVEL' ? raisedToLevel : null, // Adjust based on action
        }; 
        
        // return;
        if (!validateCheckerRemarks(transformedCheckerRemarks)) {
            return; // Stop form submission if validation fails
        }
        if (!comment || comment?.length <= 1) {
            toast.error("Overall Remarks cannot be blank and must be at least 2 characters long.")
            return;
        }
        if (buttonAction !== SUBMIT_CHECKER) {
            if(transformedCheckerRemarks && transformedCheckerRemarks.every((item)=>item.status===APPROVE) && buttonAction===REJECT){
                toast.error("Cannot be rejected, since all fields are approved.");
                return;
            }
            if(transformedCheckerRemarks && transformedCheckerRemarks.some((item)=>item.status===REJECT) && (buttonAction===APPROVE)){
                toast.error("Cannot be approved, since some fields are rejected.");
                return;
            }
        } else {
            if(transformedCheckerRemarks && transformedCheckerRemarks.every((item)=>item.status===APPROVE)){
                payload.status = 'APPROVED';
            }
            if(transformedCheckerRemarks && transformedCheckerRemarks.some((item)=>item.status===REJECT)){
                payload.status = requestDetails?.eventType == "RISK_DETAIL_SECTION" ? "REJECTED" : 'CHECKER_REJECTED'
            }
        }

        try {
            showLoader && showLoader(); // Make sure showLoader exists
            const response = await POST(API_UPDATE_MAKER_REQUEST, payload, {});
            
            const { data } = response;
            if (data && data.statusCode === apiStatusCodes.SUCCESS) {
                toast.success(SUCCESS_MESSAGES.APPLICATION_UPDATED_SUCCESSFULLY);
                history.push('/checker');
            } else {
                toast.error(data.errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.errorMessage || ERROR_MESSAGES.FALLBACK_ERROR;
            toast.error(errorMessage);
        } finally {
            if (typeof hideLoader === 'function') {
                hideLoader(); // Ensure hideLoader is called only if defined
            }
        }
    };
    return (
        <form onSubmit={handleFormSubmit} className="checker-form">
            <div className="form-field">
                {/* <p className="label">Remark</p> */}
                <FormElems.TextArea
                    handleChange={value => setComment(value)}
                    placeholder="Please enter your remarks"
                    value={comment}
                />
            </div>
            <SubmitButton 
                isViewMode={isViewMode}
                requestDetails={requestDetails}
                setIsApproved={setIsApproved}
                setButtonAction={setButtonAction}
                approveDisable={approveDisable}
                raisedToLevel={raisedToLevel}
                loggedInUserLevel={loggedInUserLevel}
                parentEventType={parentEventType}
            />
            
        </form>
    );
};

MleCheckerApprovalForm.propTypes = {
    closePopup: PropTypes.func,
    requestDetails: PropTypes.object,
    auth: PropTypes.object,
    eventType: PropTypes.string,
    showLoader: PropTypes.func,
    hideLoader: PropTypes.func,
    isViewMode: PropTypes.bool
};

export default MleCheckerApprovalForm;
